module.exports = __webpack_public_path__ + "img/rank3.9198af8e.png";